import commonUtil from '../../../utils/commonUtil';

export const GET_NEW_MEGAMENU = 'GET_NEW_MEGAMENU';
export const GET_NEW_MEGAMENU_SUCCESS = 'GET_NEW_MEGAMENU_SUCCESS';
export const GET_NEW_MEGAMENU_LOAD_FAIL = 'GET_NEW_MEGAMENU_LOAD_FAIL';

export function loadNewMegaMenu(globalState) {
  return globalState.newMegaMenuData && globalState.newMegaMenuData.loaded;
}

export function getNewMegaMenu() {
  const userEnteredData = {};
  userEnteredData.brand = commonUtil.getBrand().toUpperCase();
  userEnteredData.channel = commonUtil.getChannel().toUpperCase();
  const brand = commonUtil.getBrand().toUpperCase();
  const channel = commonUtil.getChannel().toUpperCase();
  const dataCenter = 'SiteA';
  // const categoryId = '';
  const queryString = `brand=${brand}&channel=${channel}&dataCenter=${dataCenter}&locale=es-mx`;

  return {
    types: [
      GET_NEW_MEGAMENU,
      GET_NEW_MEGAMENU_SUCCESS,
      GET_NEW_MEGAMENU_LOAD_FAIL,
    ],
    promise: (client) => client.get('/api/getNewMegaMenu?' + queryString),
  };
}
